import { render, staticRenderFns } from "./CurriculumItem.vue?vue&type=template&id=92879014&scoped=true"
import script from "./CurriculumItem.vue?vue&type=script&lang=js"
export * from "./CurriculumItem.vue?vue&type=script&lang=js"
import style0 from "./CurriculumItem.vue?vue&type=style&index=0&id=92879014&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92879014",
  null
  
)

export default component.exports